import { Loader2 } from "lucide-react";

/**
 * Lightweight full-section loader — shown via React's Suspense while a lazy
 * route module is fetched, and while navigation between routes is pending.
 */
export function PageLoader({ label = "Loading…" }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-[320px] flex-col items-center justify-center gap-3 text-sm text-muted-foreground"
    >
      <Loader2 className="h-6 w-6 animate-spin text-accent" aria-hidden="true" />
      <span className="font-medium">{label}</span>
    </div>
  );
}

/**
 * Top progress bar — visible during route transitions.
 * Pure CSS animation, no external state required.
 */
export function NavigationProgress({ active }: { active: boolean }) {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-x-0 top-0 z-50 h-0.5 overflow-hidden"
    >
      <div
        className={
          active
            ? "h-full w-1/3 animate-[slide_1.2s_ease-in-out_infinite] rounded-r-full bg-gradient-to-r from-accent/0 via-accent to-accent/0"
            : "h-full w-0"
        }
        style={{ animationName: active ? "nav-slide" : "none" }}
      />
      <style>{`
        @keyframes nav-slide {
          0%   { transform: translateX(-100%); }
          50%  { transform: translateX(100%); }
          100% { transform: translateX(300%); }
        }
      `}</style>
    </div>
  );
}
